import { useCallback, useMemo } from 'react';
import { Box, BoxProps } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';
import { styled, SxProps, Theme } from '@mui/material/styles';
import { Cross } from '@bolteu/kalep-react-icons';
import { IconButton } from '../IconButton/IconButton';
import { Typography } from '../Typography/Typography';
import { DrawerOnClose } from '../Drawer/Drawer';

const StyledDrawerTitle = styled(Box)<BoxProps>(() => ({
  padding: '16px 0',
  gap: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export interface DrawerTitleProps extends BoxProps {
  onClose?: DrawerOnClose;
  variant?: TypographyProps['variant'];
  sx?: SxProps<Theme>;
}

export function DrawerTitle({ children, onClose, variant, sx, ...props }: DrawerTitleProps) {
  const onClickClose = useCallback(() => onClose?.({}, 'closeButton'), [onClose]);
  const titleSx = useMemo(() => ({ flex: 1, ...sx }), [sx]);
  const titleVariant = variant || 'heading-xs-accent';
  return (
    <StyledDrawerTitle {...props}>
      <Typography variant={titleVariant} sx={titleSx}>
        {children}
      </Typography>
      {onClose && (
        <IconButton aria-label="close" onClick={onClickClose} color="secondary" size="small">
          <Cross />
        </IconButton>
      )}
    </StyledDrawerTitle>
  );
}
